import axios from "axios";
import { IIdRecord } from "../interfaces/interfaces";
import { adapterItemResponse } from "./adapters/adapterItem";

export const restoreRecordInDb = async (_id: string) => {
  let recordId: IIdRecord = { _id: _id };
  try {
    let restoreRecord: any = await axios({
      method: "put",
      url: "/api/restore-record",
      data: recordId,
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return error.data;
      });

    if (restoreRecord.restore === true) {
      let adaptedResponse = adapterItemResponse(restoreRecord);
      return adaptedResponse;
    }
    if (restoreRecord.restore === false) {
      return false;
    }
    return false;
  } catch (error) {
    return false;
  }
};
